import { useQuery } from '@zg-rentals/react-query5';
import { useState } from 'react';
import { useDebouncedCallback } from './useDebouncedCallback';
import { getAddressAutocomplete } from '../utils/api-ts';
import { useDispatch } from 'react-redux';

export const MIN_AUTOCOMPLETE_ADDRESS_LENGTH = 7;

export function useAddressAutocomplete({ initialAddress = '' }: { initialAddress?: string }) {
  const dispatch = useDispatch();
  const [partialAddress, setPartialAddress] = useState(initialAddress);
  const [partialAddressDebounced, setPartialAddressDebounced] = useState(initialAddress);
  const setAddressAutocompleteDebounced = useDebouncedCallback(setPartialAddressDebounced, 300);

  function onSetAddress(address: string) {
    setPartialAddress(address);
    setAddressAutocompleteDebounced(address);
  }

  const queryHook = useQuery({
    queryKey: ['getAddressAutocomplete', partialAddressDebounced.trim()],
    queryFn: () => dispatch(getAddressAutocomplete({ partialAddress: partialAddressDebounced.trim() })),
    enabled: partialAddressDebounced.trim().length >= MIN_AUTOCOMPLETE_ADDRESS_LENGTH,
  });

  return [partialAddress, onSetAddress, queryHook] as const;
}
